import PropTypes from "prop-types";
import React from "react";
import {
  StyleSheet,
  View,
  TouchableOpacity,
  Platform,
  Animated,
  Easing,
} from "react-native";
import ENV from "app/utils/ENV";
import Svg, {
  Path,
  Ellipse,
  Circle,
  Rect,
  Text as SvgText,
} from "react-native-svg";
// import { styleSheet, colors, sizes, screenRatio } from "app/utils/styleSheet";

import { StyleContext } from "app/contexts/Style";

export default class MomentRing extends React.Component {
  static contextType = StyleContext;
  static propTypes = {
    notches: PropTypes.array,
    size: PropTypes.number,
    // color: PropTypes.color,
    pulse: PropTypes.bool,
  };

  static defaultProps = {
    notches: [],
    // size: sizes.large,
    // color: colors.trim,
    strokeFactor: 1.0,
    gutter: 0,
  };

  constructor(props) {
    super(props);
    // let { notches, size } = props;

    // let complete = notches.length === 1;

    // let strokeWidth = size * 0.1;
    // let R = size / 2;
    // let C = Math.PI * size;

    // let slot = C / notches.length;
    // let slotGap = slot * 0.2;
    // let slotFill = slot - slotGap;
    // let offset = -slotGap / 2;

    // let strokeDasharray = [];
    // if (complete) {
    //   notches = [C];
    //   offset = 0;
    // } else {
    //   notches.forEach((n) => {
    //     if (!!n) {
    //       strokeDasharray.push(slotFill, slotGap);
    //     } else {
    //       // strokeDasharray.push(0, slotFill, 0, slotGap);
    //     }
    //     console.log(n, notches, !!n, strokeDasharray);
    //   });
    //   if (!!strokeDasharray.length) {
    //     strokeDasharray.pop();
    //   }
    //   strokeDasharray.push(C);
    // }
    // // if (complete) console.log("full ring:", notches, strokeDasharray, C, slot);

    // this.state = {
    //   R,
    //   C,
    //   strokeWidth,
    //   slot,
    //   slotFill,
    //   slotGap,
    //   offset,
    //   strokeDasharray,
    //   complete,
    // };
  }

  generateValues = () => {
    let { notches, size, strokeFactor, gapless, gutter, percent } = this.props;
    if (!size) size = this.context.sizes.large;

    let strokeWidth = size * 0.08 * strokeFactor;
    let R = size / 2;
    R -= gutter;
    let C = Math.PI * (size - gutter * 2);

    // let baseGap = C / 8;
    // baseGap = C / 16;
    let baseGap = 0;

    let complete = percent == 1;
    let slot;
    let slotGap;
    let offset;
    let slotFill;
    let strokeDasharray = [];

    if (gapless) {
      slot = C - baseGap;
      offset = -baseGap / 2;
      slotGap = 0;
      slotFill = slot * percent;
      if (complete) {
        slotFill = C;
        offset = 0;
      }
      // console.log(slotFill, slot, percent);
      if (!!slotFill && isFinite(slotFill)) strokeDasharray.push(slotFill);
      strokeDasharray.push(C);
    } else {
      complete = notches.length === 1 && notches[0] == 1;
      if (complete) baseGap = 0;
      slot = C / notches.length - baseGap / notches.length;
      slotGap = slot * 0.4;
      if (notches.length == 1 || gapless) {
        slotGap = 0;
      }
      offset = -baseGap / 2;

      slotFill = slot - slotGap;

      if (complete) {
        notches = [C];
        offset = 0;
      } else {
        notches.forEach((n) => {
          if (!!n) {
            strokeDasharray.push(slotFill, slotGap);
          } else {
            // strokeDasharray.push(0, slotFill, 0, slotGap);
          }
        });
        if (!!strokeDasharray.length) {
          strokeDasharray.pop();
        } else {
          // strokeDasharray.push(0);
        }
        strokeDasharray.push(C);
      }
    }
    // console.log(percent, slotFill, slotGap, strokeDasharray);
    // if (complete) console.log("full ring:", notches, strokeDasharray, C, slot);
    return {
      R,
      C,
      strokeWidth,
      slot,
      slotFill,
      slotGap,
      offset,
      strokeDasharray,
      complete,
    };
  };

  render() {
    return null;
    let { notches, size, color, wrapperStyle, gutter, pulse } = this.props;
    // let { R, C, strokeWidth, offset, strokeDasharray, complete } = this.state;
    let { R, C, strokeWidth, offset, strokeDasharray, complete } =
      this.generateValues();

    if (strokeDasharray.length == 1 && !complete) {
      // color = colors.trim;
      color = this.context.colors.empty;
      color = "transparent";
    }

    if (!this.pulseAnim && pulse) {
      this.pulseAnim = new Animated.Value(1);
      Animated.loop(
        Animated.sequence([
          Animated.timing(this.pulseAnim, {
            toValue: 0.8,
            duration: 500,
            useNativeDriver: !ENV.WEB,
          }),
          Animated.timing(this.pulseAnim, {
            toValue: 1.1,
            duration: 1000,
            useNativeDriver: !ENV.WEB,
          }),
          Animated.timing(this.pulseAnim, {
            toValue: 1.0,
            duration: 500,
            useNativeDriver: !ENV.WEB,
          }),
          Animated.delay(500),
        ]),
        // {
        //   iterations: 3,
        // }
      ).start();
    }

    return (
      <Animated.View
        style={[
          {
            ...StyleSheet.absoluteFillObject,
          },
          pulse && {
            transform: [
              // { rotate: rot },
              { scale: this.pulseAnim },
            ],
          },
          wrapperStyle,
          // { borderWidth: 2, borderColor: "cyan" },
        ]}
      >
        <View
          style={[
            styles.svgWrapper,
            {
              ...StyleSheet.absoluteFillObject,
              // height: size,
              // width: size,
              // borderRadius: size / 2,
              // borderWidth: 1,
              // borderColor: "green",
            },
          ]}
        >
          <Svg
            tabIndex={-1}
            height="100%"
            width="100%"
            viewBox={`0 0 ${size} ${size}`}
          >
            <Circle
              tabIndex={-1}
              cx={size / 2}
              cy={size / 2}
              r={R}
              stroke={color}
              strokeWidth={strokeWidth}
              fill="transparent"
              strokeDasharray={strokeDasharray}
              strokeDashoffset={offset}
              strokeLinecap={complete ? "square" : "round"}
              tabIndex={-1}
              d={`M${R * 2 + strokeWidth * 2},0 l0,${R * 2}`}
            />
          </Svg>
        </View>
      </Animated.View>
    );
  }
}

const styles = StyleSheet.create({
  svgWrapper: {
    transform: [
      {
        rotate: "90deg",
      },
    ],
  },
});
